import { createModel } from "@rematch/core";
import type { RootModel } from ".";
import { PaginationFactory } from "../factory";
import { AppointmentTypes } from "../types/appointment.types";

export interface AppointmentStoreProps {
    pagination: PaginationFactory<AppointmentTypes.Model>,
    enrichedPagination: PaginationFactory<AppointmentTypes.Model>,
    summary: AppointmentTypes.Summary | null,
    loading: {
        fetchMany: boolean,
        fetchEnriched: boolean,
    }
}

export const appointmentInitialState = {
    pagination: {} as PaginationFactory<AppointmentTypes.Model>,
    enrichedPagination: {} as PaginationFactory<AppointmentTypes.Model>,
    summary: null as AppointmentTypes.Summary | null,
    loading: {
        fetchMany: false,
        fetchEnriched: false,
    }
}

export const appointment = createModel<RootModel>()({
    state: appointmentInitialState,
    reducers: {
        toggleLoading: (store, prop: keyof AppointmentStoreProps['loading'], v: boolean) => {
            store.loading[prop] = v;
        },
        setPagination: (store, pagination: PaginationFactory<AppointmentTypes.Model>) => {
            store.pagination = pagination;
        },
        setEnrichedPagination: (store, pagination: PaginationFactory<AppointmentTypes.Model>) => {
            store.enrichedPagination = pagination;
        },
        setSummary: (store, summary: AppointmentTypes.Summary | null) => {
            store.summary = summary;
        },
    },
});